import validator from "validator";
import { CREATE_SHIPPING_PLAN_CHECK_POST_SUCCESS, CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_FAILURE, CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_REQUEST, CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_SUCCESS, CREATE_SHIPPING_PLAN_DETAILS_GET_FAILURE, CREATE_SHIPPING_PLAN_DETAILS_GET_REQUEST, CREATE_SHIPPING_PLAN_DETAILS_GET_SUCCESS, CREATE_SHIPPING_PLAN_DETAILS_POST_SUCCESS, CREATE_USER_FORM_SHIPPING_PLAN_DETAILS, DELETE_SHIPPING_PLAN_DETAILS_FAILURE, DELETE_SHIPPING_PLAN_DETAILS_REQUEST, SHIPPING_PLAN_DETAILS_USERFORM_RESET } from "./shippingPlanDetails.actionType";

export const SHIPPING_PLAN_DETAILS = 'shippingPlanDetails'


let initialState = {
    loading: false,
    userform: {
        FldLength: '',
        FldBreadth: '',
        FldHeight: ''
    },
    shippingPlanDetailsGet: [],

};




export let shippingDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case CREATE_SHIPPING_PLAN_DETAILS_GET_REQUEST:
        case DELETE_SHIPPING_PLAN_DETAILS_REQUEST:
        case CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_REQUEST:
            return {
                ...state,
                loading: true,
            }

        case SHIPPING_PLAN_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    FldLength: '',
                    FldBreadth: '',
                    FldHeight: '',
                    FldInnerPackQty: '',
                    FldInnerPackPerBox: '',
                    fldQuantity: '',
                    fldPONo: ''
                },
                loading: false,
            }


        case CREATE_SHIPPING_PLAN_DETAILS_POST_SUCCESS:
            // localStorage.setItem('fromBoxes', updatePayload)
            // let data = localStorage.getItem('fromBoxes')

            return {
                ...state,
                loading: false,
                // prevFromBoxes: data
            }

        case CREATE_USER_FORM_SHIPPING_PLAN_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }

        case CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                fromDropLists: updatePayload.CUD
            }

        case CREATE_SHIPPING_PLAN_CHECK_POST_SUCCESS:
            return {
                ...state,
                loading: false,
                validatorList: updatePayload

            }
        case CREATE_SHIPPING_PLAN_DETAILS_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                shippingPlanDetailsGet: updatePayload

            }

        case CREATE_SHIPPING_PLAN_DETAILS_GET_FAILURE:
        case DELETE_SHIPPING_PLAN_DETAILS_FAILURE:
        case CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            }

        default:
            return state;
    }
};